export const getInitialValueForFormGroup = (userData, key) => {
  for (const data of userData) {
    if (data.key === key) {
      return data?.value;
    }
  }
  return '';
};

export const updateMiCallbackUiAfterSave = ({
  myinfoData,
  setMyinfoData,
  newValue,
  key,
  handleCloseSideSheet,
  setShowToast,
}) => {
  let getNewValue = '';
  if (key === 'mobileno') {
    getNewValue = `+65${newValue.replace(/\D/g, '')}`;
  } else {
    getNewValue = newValue;
  }
  const dataArray = [...myinfoData.data];
  for (const data of dataArray) {
    if (data.key === key) {
      data.value = getNewValue;
    }
  }
  const myinfoDataCopy = { ...myinfoData, data: dataArray };
  setMyinfoData(myinfoDataCopy);
  setShowToast(true);
  handleCloseSideSheet();
};

export const parseMobileInputDisplay = (mobileNumber) => {
  if (!mobileNumber) {
    return '';
  }
  const replace = mobileNumber.replace(/\D/g, '');
  return replace.replace(/(\d{4})/g, '$1 ').trim();
};

// to send the string number back to backend
export const marriageStatusMapping = {
  Single: '1',
  Married: '2',
  Widowed: '3',
  Divorce: '5',
};

export const checkSameAsMyinfoAndVerified = (inputVal, value, key) => {
  const parseInput = key === 'mobileno' && inputVal ? `${inputVal.replace(/\D/g, '')}` : inputVal;
  return parseInput === value;
};

export const handleCancel = ({
  flowType,
  commonTrackingParams,
  trackSegment,
  getUtmParam,
  handleCloseSideSheet,
}) => {
  if (flowType === 'myinfo') {
    const trackingParams = {
      ...commonTrackingParams,
      buttonName: 'myinfo cancel',
    };
    trackSegment && trackSegment('Button Clicked', trackingParams, getUtmParam);
  }
  handleCloseSideSheet();
};
